import Loader from '../Shared/Loader'

interface LoadingPageProps {
    className?: string
}

const LoadingPage = ({className}: LoadingPageProps) => {
    return (
        <div className={`absolute top-[50dvh] -translate-y-1/2 left-1/2 -translate-x-1/2 ${className}`}>
            <Loader/>
        </div>
    )
}

export default LoadingPage
